export default {"src":"/_next/static/media/cyclist.colour.d91abc82.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};